module.exports = __webpack_public_path__ + "fonts/Overpass-Bold.d02d0d10.ttf";